module.exports = __webpack_public_path__ + "static/media/maintenance.c0b0e4de.svg";